<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

// Declare variables globally

const hamburger = document.getElementById('hamburger');
const wishlist = document.getElementById('wishlist-icon');
const searchIcon = document.getElementById('search-btn');
const menuDrawer = document.getElementById('sideMenu');
const searchDrawer = document.getElementById('side-search-container');
const drawerOverlay = document.getElementById('drawer-overlay');
const drawerOverlay2 = document.getElementById('drawer-overlay2');
const navigationContainer = document.getElementById('container-marwell-style');
const closeSearch = document.getElementById('close-search');
const sideCart = document.getElementById('side-cart-container');
const cartIcon = document.getElementById('navigation-shop-cart-icon');
const cartClose = document.getElementById('close-cart');


// Function to close all drawers
function closeAllDrawers() {
    menuDrawer.classList.remove('open');
    searchDrawer.classList.remove('active');
    hamburger.classList.remove('active');
    hamburger.classList.remove('black');
    searchIcon.classList.remove('active');
    drawerOverlay.classList.remove('active');
    drawerOverlay2.classList.remove('active');
    navigationContainer.classList.remove('active');
    sideCart.classList.remove('open');
    wishlist.classList.remove('active');
}
//Update Cart
function updateCartCount() {
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      const countBubble = document.querySelector(".cart-count-bubble .text");
      if (countBubble) {
        countBubble.textContent = cart.item_count;
      }
      const hiddenLabel = document.querySelector(".cart-count-bubble .visually-hidden");
      if (hiddenLabel) {
        hiddenLabel.textContent = `${cart.item_count} items`;
      }
    })
    .catch(err => console.error("❌ Error updating cart count:", err));
}

// CLOSE ALL DRAWERS WHEN CLICKING EITHER OVERLAY
document.addEventListener("click", function (e) {
  const overlay = e.target.closest("#drawer-overlay, #drawer-overlay2");
  const accountIcon = document.querySelector('#header-mobile--icon');
  const cartIcon = document.querySelector('#header-mobile--icon-cart');
  if (!overlay) return;

  e.preventDefault();
  updateCartCount();
  closeAllDrawers();
  // Close side cart
  const sideCart = document.querySelector("#side-cart-container");
  if (sideCart) {
    sideCart.classList.remove("open");
    navigationContainer.classList.remove('active');
    accountIcon.classList.remove('active');
    cartIcon.classList.remove('active');
  }
  // Close side menu (left drawer)
  const sideMenu = document.querySelector("#sideMenu");
  if (sideMenu) {
    sideMenu.classList.remove("open");
    navigationContainer.classList.remove('active');
    accountIcon.classList.remove('active');
    cartIcon.classList.remove('active');
  }
  // Close search drawer (right drawer)
  const sideSearch = document.querySelector("#side-search-container"); 
  if (sideSearch) {
    sideSearch.classList.remove("active");
    navigationContainer.classList.remove('active');
    accountIcon.classList.remove('active');
    cartIcon.classList.remove('active');
  }

  // Remove body classes
  document.body.classList.remove("sidecart-open", "scroll-locked", "menu-open", "search-open");

  // Hide overlays
  document.querySelectorAll("#drawer-overlay, #drawer-overlay2").forEach(el => el.classList.remove("active"));
});
//ESCAPE KEY
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    document.querySelectorAll("#drawer-overlay, #drawer-overlay2").forEach(el => el.classList.remove("active"));
    document.querySelector("#side-cart-container")?.classList.remove("open");
    document.querySelector("#sideMenu")?.classList.remove("open");
    document.querySelector("#side-search-container")?.classList.remove("active");
    document.body.classList.remove("sidecart-open", "scroll-locked", "menu-open", "search-open");
    document.querySelector("#container-marwell-style")?.classList.remove("active");
    document.querySelector("#header-mobile--icon")?.classList.remove("active");
    document.querySelector("#header-mobile--icon-cart")?.classList.remove("active");
    document.querySelector("#wishlist-icon")?.classList.remove("active");
    document.querySelector("#hamburger")?.classList.remove("active");
    document.querySelector("#hamburger")?.classList.remove("black");
    document.querySelector("#search-btn")?.classList.remove("active");
    updateCartCount();
  }
});
// Event listener for hamburger
hamburger.addEventListener('click', function () {
    const isMenuOpen = menuDrawer.classList.contains('open');
    const isHamburgerOpen = hamburger.classList.contains('active');
    const isDrawerOverlay = drawerOverlay.classList.contains('active');
    const isNavigationContainer = navigationContainer.classList.contains('active');
    const isWishlist = wishlist.classList.contains('active');

    closeAllDrawers();
    if (!isMenuOpen) {
        hamburger.classList.toggle('active');
        menuDrawer.classList.add('open');
        drawerOverlay.classList.add('active');
        navigationContainer.classList.add('active');
        wishlist.classList.add('active');

    }
});

// Event listener for search icon
searchIcon.addEventListener('click', function () {
    const isSearchOpen = searchDrawer.classList.contains('active');
    const isHamburgerOpen = hamburger.classList.contains('black');
    const isSearchIcon = searchIcon.classList.contains('active');
    const isDrawerOverlay2 = drawerOverlay2.classList.contains('active');
    const isNavigationContainer = navigationContainer.classList.contains('active');
    const isWishlist = wishlist.classList.contains('active');
    // const isheaderIcons = headerIcons.classList.contains('active');
    closeAllDrawers();
    if (!isSearchOpen) {
        hamburger.classList.toggle('black');
        searchIcon.classList.toggle('active');
        searchDrawer.classList.add('active');
        drawerOverlay2.classList.add('active');
        navigationContainer.classList.add('active');
        wishlist.classList.add('active');
    }
});

//Event listener for Cart icon
cartIcon.addEventListener('click', function () {
    const isHamburgerOpen = hamburger.classList.contains('black');
    const isDrawerOverlay2 = drawerOverlay2.classList.contains('active');
    const isNavigationContainer = navigationContainer.classList.contains('active');
    const isSideCart = sideCart.classList.contains('open');
    const isWishlist = wishlist.classList.contains('active');
    // const isheaderIcons = headerIcons.classList.contains('active')
    closeAllDrawers();
    if (!isSideCart) {
        hamburger.classList.toggle('black');
        searchIcon.classList.toggle('active');
        drawerOverlay2.classList.add('active');
        navigationContainer.classList.add('active');
        sideCart.classList.add('open');
        wishlist.classList.add('active');
    }
});

// Event listener for Cart X icon
cartClose.addEventListener('click', function () {
    const isSearchOpen = searchDrawer.classList.contains('active');
    const isHamburgerOpen = hamburger.classList.contains('black');
    const isSearchIcon = searchIcon.classList.contains('active');
    const isDrawerOverlay2 = drawerOverlay2.classList.contains('active');
    const isNavigationContainer = navigationContainer.classList.contains('active');
    const isWishlist = wishlist.classList.contains('active');
    // const isheaderIcons = headerIcons.classList.contains('active')
    closeAllDrawers();
    if (!isSideCart) {
        hamburger.classList.toggle('black');
        searchIcon.classList.toggle('active');
        searchDrawer.classList.add('active');
        drawerOverlay2.classList.add('active');
        navigationContainer.classList.add('active');
        wishlist.classList.add('active');
    }
});

// Event listener for Search X icon
closeSearch.addEventListener('click', function () {
    const isSearchOpen = searchDrawer.classList.contains('active');
    const isHamburgerOpen = hamburger.classList.contains('black');
    const isSearchIcon = searchIcon.classList.contains('active');
    const isDrawerOverlay2 = drawerOverlay2.classList.contains('active');
    const isNavigationContainer = navigationContainer.classList.contains('active');
    const isWishlist = wishlist.classList.contains('active');
    // const isheaderIcons = headerIcons.classList.contains('active')
    closeAllDrawers();
    if (!isSearchOpen) {
        hamburger.classList.toggle('black');
        searchIcon.classList.toggle('active');
        searchDrawer.classList.add('active');
        drawerOverlay2.classList.add('active');
        navigationContainer.classList.add('active');
        wishlist.classList.add('active');
    }
});

// Toogle Scroll lock
 hamburger.addEventListener('click', () => {
    document.body.classList.toggle('scroll-locked');
  });
searchIcon.addEventListener('click', () => {
  document.body.classList.toggle('scroll-locked');
})
closeSearch.addEventListener('click', () => {
  document.body.classList.toggle('scroll-locked');
})
cartIcon.addEventListener('click', () => {
  document.body.classList.toggle('scroll-locked');
})
cartClose.addEventListener('click', () => {
  document.body.classList.toggle('scroll-locked');
})
// Toggle submenus on click
document.querySelectorAll('.menu-item.has-children > .menu-link').forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();

    const parentLi = this.parentElement;

    // Close other open submenus at same level
    document.querySelectorAll('.menu-item.open').forEach(openItem => {
      if (openItem !== parentLi) {
        openItem.classList.remove('open');
      }
    });

    // Toggle this submenu
    parentLi.classList.toggle('open');
  });
});

// Toggle sub-submenus
document.querySelectorAll('.submenu-item.has-children > .menu-link').forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();

    const parentLi = this.parentElement;

    // Close other open sub-submenus at same level
    parentLi.parentElement.querySelectorAll('.submenu-item.open').forEach(openItem => {
      if (openItem !== parentLi) {
        openItem.classList.remove('open');
      }
    });

    // Toggle this sub-submenu
    parentLi.classList.toggle('open');
  });
});



//CLOSE SIDE SEARCH
const closeBtn = document.querySelector('.close-search');
  closeBtn.addEventListener('click', () => {
  sideSearch.classList.remove('active');
  drawerOverlay.classList.remove('active');
  navigationContainer.classList.remove('active');
  hamburger.classList.remove('active');
  headerIcons.classList.remove('active')
});

document.addEventListener('DOMContentLoaded', function() {
    const hamburger = document.querySelector('#hamburger');
    const accountIcon = document.querySelector('#header-mobile--icon');
    const cartIcon = document.querySelector('#header-mobile--icon-cart')

    closeAllDrawers();
    // Check if elements exist
    if (!hamburger || !accountIcon || !cartIcon) return;

    hamburger.addEventListener('click', function() {
        accountIcon.classList.toggle('active');
        cartIcon.classList.toggle('active');
    });
    cartIcon.addEventListener('click', function(){
        accountIcon.classList.toggle('active');
        cartIcon.classList.toggle('active');
    })
});
///////////////////////////////////////////////////
// ADD TO CART + OPEN SIDE CART + UPDATE HEADER
document.addEventListener("DOMContentLoaded", function () {
  const atcBtn = document.querySelector("#product-add-to-cart");

  if (!atcBtn) return;

  atcBtn.addEventListener("click", function (e) {
    e.preventDefault();

    // Get product form
    const form = atcBtn.closest("form");
    if (!form) {
      console.error("⚠️ No form found for Add to Cart button");
      return;
    }

    // Get variant ID
    const variantInput = form.querySelector("input[name='id']");
    const variantId = variantInput ? variantInput.value : null;

    // Get quantity
    const qtyInput = form.querySelector("input[name='quantity']");
    let qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(qty) || qty < 1) qty = 1; // fallback to 1

    if (!variantId) {
      console.error("⚠️ No variant ID found.");
      return;
    }

    // Add to cart
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("✅ Added to cart:", data);

        // Reload BOTH side cart + header
        return fetch(`/?sections=side-cart,header&ts=${Date.now()}`);
      })
      .then((res) => res.json())
      .then((sections) => {
        // Update side cart safely
        const sideCartContainer = document.querySelector("#side-cart-container");
        if (sideCartContainer && sections["side-cart"]) {
          // Parse the HTML to get the inner content of side-cart-container
          const parser = new DOMParser();
          const doc = parser.parseFromString(sections["side-cart"], "text/html");
          const inner = doc.querySelector("#side-cart-container");
          if (inner) {
            sideCartContainer.innerHTML = inner.innerHTML; // ✅ inject only inner content
            document.body.classList.add("scroll-locked");
            drawerOverlay2.classList.add('active');
            sideCartContainer.classList.add("open");
            console.log("✅ Side cart updated");
          }
        } else {
          console.warn("⚠️ Side cart section missing in response");
        }

        // Update header
        if (sections["header"]) {
          const oldHeader = document.querySelector("header");
          if (oldHeader) {
            oldHeader.outerHTML = sections["header"];
            console.log("✅ Header updated with new cart count");
          }
        }
      })
      .catch((err) => console.error("ATC error:", err));
  });
});
// SIDE CART CLOSE BUTTON
document.addEventListener("click", function(e) {
  const closeBtn = e.target.closest("#close-cart");
  if (!closeBtn) return;

  e.preventDefault();
  const sideCart = document.querySelector("#side-cart-container");
  if (sideCart) {
    updateCartCount();
    sideCart.classList.remove("open");
    document.body.classList.remove("scroll-locked"); // unlock scrolling
    drawerOverlay2.classList.remove('active');
  }
});

// REMOVING ITEMS FROM CART USING X ICON
document.addEventListener("click", function(e) {
  const btn = e.target.closest("[data-cart-remove]");
  if (!btn) return;

  e.preventDefault();

  const lineKey = btn.getAttribute("data-line"); // Use the item key

  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ key: lineKey, quantity: 0 }) // remove item by key
  })
  .then(res => res.json())
  .then(() => fetch(`/?sections=side-cart,header&ts=${Date.now()}`))
  .then(res => res.json())
  .then(sections => {
    const sideCartContainer = document.querySelector("#side-cart-container");
    if (sideCartContainer && sections["side-cart"]) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sections["side-cart"], "text/html");
      const inner = doc.querySelector("#side-cart-container");
      if (inner) sideCartContainer.innerHTML = inner.innerHTML;

      // If cart is empty, close side cart and unlock scroll
      const isEmpty = !sideCartContainer.querySelector(".previewCartItem");
      if (isEmpty) {
        sideCartContainer.classList.remove("open");
        document.body.classList.remove("scroll-locked");
        drawerOverlay2.classList.remove('active');
        navigationContainer.classList.remove('active');
        updateCartCount();
        closeAllDrawers();
      } else {
        document.body.classList.add("scroll-locked");
      }
    }

    // Update header cart count
    if (sections["header"]) {
      const oldHeader = document.querySelector("header");
      if (oldHeader) oldHeader.outerHTML = sections["header"];
    }
  })
  .catch(err => console.error("❌ Error removing from cart:", err));
});

// PRODUCT RECOMMENDATION ON CART
function loadCartRecommendations() {
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      const container = document.getElementById("cart-related-products");

      if (!cart.items.length) {
        // Show empty cart state
        const previewCart = document.querySelector(".previewCart");
        if (previewCart) {
          previewCart.innerHTML = `
            <div class="previewCart-emptyBody text-center">
              <div class="empty">
                <span class="text">
                  ${window.theme?.translations?.cart_empty || "Your cart is empty"}
                </span>
              </div>
              <a class="button button-2 button-continue continue-shopping-btn"
                ${window.theme?.settings?.quick_cart_redirect_button === "go_back"
                  ? 'role="link" aria-disabled="true" onclick="window.history.back();"'
                  : window.theme?.settings?.quick_cart_redirect_button === "link_to"
                    ? 'href="' + (window.theme?.settings?.quick_cart_redirect_button_link || "/") + '"'
                    : 'role="link" aria-disabled="true" onclick="window.location.reload();"'
                }
              >
                ${window.theme?.translations?.continue_shopping || "Continue Shopping"}
              </a>
            </div>
          `;
        }

        // Clear out recommendations if they exist
        if (container) {
          container.innerHTML = "";
        }
        return;
      }

      const firstProductId = cart.items[0].product_id;

      // Fetch product recommendations
      fetch(`/recommendations/products.json?product_id=${firstProductId}&limit=6`)
        .then(res => res.json())
        .then(data => {
          if (!container) return;

          if (data.products && data.products.length) {
            container.innerHTML = `
              <div class="previewCartCarousel">
                <div class="carousel-track">
                  ${data.products
                    .map(
                      p => `
                        <div class="product-slide">
                          <a href="${p.url}" class="product-link">
                            <img src="${p.featured_image}" alt="${p.title}" loading="lazy" />
                            <div class="cart-product-title"><p>${p.title}</p></div>
                            <div class="cart-product-title">
                              <p>$${(p.price / 100).toFixed(2)}</p>
                            </div>
                          </a>
                        </div>
                      `
                    )
                    .join("")}
                </div>
                <button class="carousel-prev">‹</button>
                <button class="carousel-next">›</button>
              </div>
            `;

            initCartSlider(container.querySelector(".previewCartCarousel"));
          } else {
            container.innerHTML = "<p>No recommendations found.</p>";
          }
        })
        .catch(err => console.error("❌ Error fetching recommendations:", err));
    })
    .catch(err => console.error("❌ Error fetching cart:", err));
}

// Vanilla JS slider (2 products visible)
function initCartSlider(wrapper) {
  const track = wrapper.querySelector(".carousel-track");
  const slides = wrapper.querySelectorAll(".product-slide");
  const prevBtn = wrapper.querySelector(".carousel-prev");
  const nextBtn = wrapper.querySelector(".carousel-next");

  let index = 0;
  const visible = 2;

  function updateSlider() {
    const slideWidth = slides[0].offsetWidth;
    track.style.transform = `translateX(-${index * slideWidth}px)`;
  }

  nextBtn.addEventListener("click", () => {
    if (index < slides.length - visible) {
      index++;
      updateSlider();
    }
  });

  prevBtn.addEventListener("click", () => {
    if (index > 0) {
      index--;
      updateSlider();
    }
  });

  updateSlider();
}

// Run once on page load
document.addEventListener("DOMContentLoaded", loadCartRecommendations);	

// Re-run every time the cart updates
document.addEventListener("cart:updated", loadCartRecommendations);

// Reload recommendations when Add to Cart clicked
document.addEventListener("click", function (e) {
  if (e.target.closest("#product-add-to-cart")) {
    setTimeout(loadCartRecommendations, 1000);
  }
});
// 


//FOR COLLECTION TOOLBAR

(function () {
  function initToolbarDropdowns() {
    const dropdowns = document.querySelectorAll('.toolbar-dropdown');
    if (!dropdowns.length) return;
    console.debug('toolbar-dropdown: found', dropdowns.length);

    dropdowns.forEach(dropdown => {
      // avoid double-init
      if (dropdown.dataset._tdInit === '1') return;
      dropdown.dataset._tdInit = '1';

      const toggle = dropdown.querySelector('.label-tab');
      const menu = dropdown.querySelector('.dropdown-menu');
      const labelText = dropdown.querySelector('.label-text');
      const items = Array.from(dropdown.querySelectorAll('[data-limited-view-item]'));

      if (!toggle || !menu || !labelText) {
        console.warn('toolbar-dropdown: missing required element(s)', { toggle, menu, labelText, dropdown });
        return;
      }

      // accessibility
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('aria-haspopup', 'listbox');
      toggle.setAttribute('aria-expanded', 'false');
      menu.setAttribute('role', 'listbox');

      items.forEach((item, i) => {
        item.setAttribute('role', 'option');
        item.setAttribute('tabindex', '0');
      });

      function openDropdown() {
        dropdown.classList.add('open');
        toggle.setAttribute('aria-expanded', 'true');
      }
      function closeDropdown() {
        dropdown.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      }

      toggle.addEventListener('click', e => {
        e.stopPropagation();
        if (dropdown.classList.contains('open')) closeDropdown(); else openDropdown();
      });

      // allow clicking the inner span or li
      function selectItem(item) {
        items.forEach(i => i.classList.remove('is-active'));
        item.classList.add('is-active');

        const span = item.querySelector('.text');
        const value = span ? (span.dataset.value ?? span.textContent.trim()) : item.textContent.trim();
        if (value !== undefined && value !== null) {
          labelText.textContent = value;
        }

        closeDropdown();

        // emit change event
        dropdown.dispatchEvent(new CustomEvent('paginateChange', {
          detail: { value: isNaN(parseInt(value, 10)) ? value : parseInt(value, 10) }
        }));
        console.debug('toolbar-dropdown: selected', value);
      }

      items.forEach(item => {
        item.addEventListener('click', e => {
          e.stopPropagation();
          selectItem(item);
        });
        item.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectItem(item);
          }
        });
      });

      // close on outside click
      document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target)) closeDropdown();
      });

      // close on Escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeDropdown();
      });
    });
  }

  // init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToolbarDropdowns);
  } else {
    initToolbarDropdowns();
  }

  // Watch for dynamically added dropdowns
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes.length) {
        // re-init — safe because we guard with data attribute
        initToolbarDropdowns();
        break;
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();


